import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowDownToLine, ArrowUpFromLine } from "lucide-react";

const ITEMS = [
  { to: "/wallet?open=deposit", label: "Recharge", hint: "Add coins", icon: ArrowDownToLine, tone: "text-green-400 bg-green-400/10", testid: "home-recharge-shortcut" },
  { to: "/wallet?open=withdraw", label: "Withdraw", hint: "Cash out", icon: ArrowUpFromLine, tone: "text-pazer-red bg-pazer-red/10", testid: "home-withdraw-shortcut" },
];

export function WalletShortcuts() {
  return (
    <div className="grid grid-cols-2 gap-2" data-testid="wallet-shortcuts">
      {ITEMS.map((it, i) => (
        <motion.div key={it.label} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.06 }}>
          <Link to={it.to} data-testid={it.testid}
            className="flex items-center gap-2.5 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 px-3 py-2 transition-colors">
            <span className={`h-8 w-8 rounded-lg flex items-center justify-center shrink-0 ${it.tone}`}><it.icon className="h-4 w-4" /></span>
            <span className="leading-tight">
              <span className="block text-sm font-semibold">{it.label}</span>
              <span className="block text-[11px] text-white/40">{it.hint}</span>
            </span>
          </Link>
        </motion.div>
      ))}
    </div>
  );
}
